import React from 'react';
import './Scheduler.css';
import {
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, FormControlLabel, FormGroup,
    InputLabel, LinearProgress, ListItem, ListItemIcon, ListItemText,
    MenuItem,
    Select,
    Tab,
    Tabs,
    List,
    FormControl,
    ThemeProvider,
    createTheme,
    Typography
} from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button as MTLButton, ListItemButton, Stack } from "@mui/material";
import { Button } from "../../../components/FormZero/Button/Button";
import { GenerateSample, RandomNumber, RowNumber } from "sample_random_data_generator";
import { RouteDialog } from '../RouteDialog'
import { FormPane } from "../../../components/FormZero/PageComponents/FormPane/FormPane";
import { Subject } from "rxjs";
import axios from "axios";
import {
    faCheckCircle,
    faMinusCircle,
    faNotEqual, faPlusCircle,
    faTimesCircle
} from "@fortawesome/free-solid-svg-icons";
import { get_number_of_trays_per_cart, isFlaggedNumberOfCarts } from "../../CommonInfo";
import {
    convertDateToBallCalendar
} from "../../../components/FormZero/PageComponents/FormPane/SubComponents/Form_WeekSelection";
import { ISearchChips } from '../../../interfaces/Core/ISearchChips';
import SearchChips from '../../../components/SearchChips';



const getAssignedValueOrDefault = function (container: any, key1: any, key2: any, DefaultValue: any = "") {
    return (container !== undefined && container[key1] !== undefined && container[key1] !== null && container[key1][key2] !== undefined) ? container[key1][key2] : DefaultValue;
}

function AssignDriverDialog(props: { driverList: any; currentRouteData: any; updateView: any; }) {



    const { driverList, currentRouteData, updateView } = props;

    const [open, setOpen] = React.useState(false);
    const [driver, setDriver] = React.useState(getAssignedValueOrDefault(currentRouteData, 'driver', 'id'));
    React.useEffect(() => {
        setDriver(getAssignedValueOrDefault(currentRouteData, 'driver', 'id'))
    }, [
        getAssignedValueOrDefault(currentRouteData, 'driver', 'id'),
        open
    ]);
    // const [driverList, setDriverList] = React.useState(sampleDrivers);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSaveAndClose = () => {
        // alert("Save?");
        const save = async function () {
            try {
                // const result
                console.log(currentRouteData);
                await axios.put(`${process.env.REACT_APP_ENDPOINT}/api/Loads/${currentRouteData.id}`, {
                    driverId: driver
                });
                updateView().then();
                setOpen(false);
            } catch (e) {
                console.log(e);
                // setResult(e);
            }
        };
        // setOpen(false);
        save().then();
    }

    const handleChange = (event: { target: { value: any; }; }) => {
        setDriver(event.target.value);
    };

    return (<>
        <MTLButton
            variant="contained"
            color={getAssignedValueOrDefault(currentRouteData, 'driver', 'DriverName', null) !== null ? "primary" : "warning"}
            fullWidth={true}
            onClick={(event) => {
                event.stopPropagation();
                handleClickOpen();
            }}
        >Assign Driver
            [{getAssignedValueOrDefault(currentRouteData, 'driver', 'DriverName', "No Driver Assigned")}]</MTLButton>
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Assign Driver</DialogTitle>
            <DialogContent style={{ width: "300px" }}>
                <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-label">Driver</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={driver}
                        label="Route"
                        onChange={handleChange}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left"
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            },
                        }}
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        {driverList.map((x: { id: any; DriverName: any; }) => (<MenuItem key={x.id} value={x.id}>{x.DriverName}</MenuItem>))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Stack direction="row" spacing={2}>
                    <Button onClick={handleClose} text={"Cancel"} />
                    <Button onClick={handleSaveAndClose} text={"Save"} color={"secondary"} />
                </Stack>
            </DialogActions>
        </Dialog>
    </>);
}

function AssignTruckDialog(props: { currentTruck?: any; truckList?: never[] | undefined; currentRouteData: any; updateView: any; }) {
    const { currentTruck, truckList = [], currentRouteData, updateView } = props;

    const [open, setOpen] = React.useState(false);
    // const [truckList, setTruckList] = React.useState(sampleTrucks);
    const [truck, setTruck] = React.useState(getAssignedValueOrDefault(currentRouteData, 'truck', 'id'));
    React.useEffect(() => {
        setTruck(getAssignedValueOrDefault(currentRouteData, 'truck', 'id'))
    }, [
        getAssignedValueOrDefault(currentRouteData, 'driver', 'id'), open]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSaveAndClose = () => {
        const save = async function () {
            try {
                console.log(currentRouteData);
                await axios.put(`${process.env.REACT_APP_ENDPOINT}/api/Loads/${currentRouteData.id}`, {
                    logistics_truck_id: truck
                });
                updateView().then();
                setOpen(false);
            } catch (e) {
                console.log(e);
            }
        };
        // setOpen(false);
        save().then();
    }

    const handleChange = (event: { target: { value: any; }; }) => {
        setTruck(event.target.value);
    };

    return (<>
        <MTLButton
            variant="contained"
            color={getAssignedValueOrDefault(currentRouteData, 'truck', 'TruckNumber', null) !== null ? "primary" : "warning"}
            fullWidth={true}
            onClick={(event) => {
                event.stopPropagation();
                handleClickOpen();
            }}
        >Assign Truck
            [{getAssignedValueOrDefault(currentRouteData, 'truck', 'TruckNumber', "No Truck Assigned")}]</MTLButton>
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Assign Truck</DialogTitle>
            <DialogContent style={{ width: "300px" }}>
                <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-label">Truck</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={truck}
                        label="Route"
                        onChange={handleChange}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left"
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            }
                        }}
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        {truckList.map((x: { id: any; truckNumber: any; }) => (<MenuItem key={x.id} value={x.id}>{x.truckNumber}</MenuItem>))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <MTLButton variant='contained' fullWidth onClick={handleClose}><Typography variant='h6' fontWeight={700}>Close</Typography></MTLButton>
                <MTLButton variant='contained' fullWidth onClick={handleSaveAndClose} color='secondary'><Typography variant='h6' fontWeight={700}>Save</Typography></MTLButton>
            </DialogActions>
        </Dialog>
    </>);
}

function AssignTrailerDialog(props: { currentTrailer: any; trailerList?: never[] | undefined; currentRouteData: any; updateView: any; }) {
    const { currentTrailer, trailerList = [], currentRouteData, updateView } = props;

    const [open, setOpen] = React.useState(false);
    // const [truckList, setTruckList] = React.useState(sampleTrucks);
    const [trailer, setTrailer] = React.useState(getAssignedValueOrDefault(currentRouteData, 'trailer', 'id'));
    React.useEffect(() => {
        setTrailer(getAssignedValueOrDefault(currentRouteData, 'trailer', 'id'))
    }, [
        getAssignedValueOrDefault(currentRouteData, 'trailer', 'id'), open]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSaveAndClose = () => {
        const save = async function () {
            try {
                // const result
                console.log(currentRouteData);
                await axios.put(`${process.env.REACT_APP_ENDPOINT}/api/Loads/${currentRouteData.id}`, {
                    logistics_trailer_id: trailer
                });
                updateView().then(() => setOpen(false));
            } catch (e) {
                console.log(e);
                // setResult(e);
            }
        };
        // setOpen(false);
        save().then();
    }

    const handleChange = (event: { target: { value: any; }; }) => {
        setTrailer(event.target.value);
    };

    /*

    getAssignedValueOrDefault(currentRouteData, 'trailer', 'TrailerNumber', null)

    <div>
        <p style={{lineHeight: '3', verticalAlign: "middle"}}>
            Trailer:
            <span style={{color: isValueAssigned(currentRouteData, 'trailer', 'TrailerNumber') ? "black": 'red'}}>{
                isValueAssigned(currentRouteData, 'trailer', 'TrailerNumber') ?
                    currentRouteData['trailer']['TrailerNumber'] : "[No Trailer  Assigned]"
            }</span>
        </p>
    </div>

     */
    // getAssignedValueOrDefault(currentRouteData, 'truck', 'capacity', 0) > 0 &&
    // TODO: have a check of if the truck number has capacity and then show good/bad indicator.

    return (<>
        <MTLButton
            variant="contained"
            color={

                getAssignedValueOrDefault(currentRouteData, 'trailer', 'TrailerNumber', null) !== null ? "primary" : "warning"

            }
            fullWidth={true}
            onClick={(event) => {
                event.stopPropagation();
                handleClickOpen();
            }}
        >Assign Trailer
            [{getAssignedValueOrDefault(currentRouteData, 'trailer', 'TrailerNumber', 'No Trailer  Assigned')}]</MTLButton>
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Assign Trailer</DialogTitle>
            <DialogContent style={{ width: "300px" }}>
                <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-label">Trailer</InputLabel>
                    <Select
                        // variant={"outlined"}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={trailer}
                        label="Route"
                        onChange={handleChange}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left"
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            }
                        }}
                    // input={<OutlinedInput label="Route" />}
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        {trailerList.map((x: { id: any; TrailerNumber: any; }) => (<MenuItem key={x.id} value={x.id}>{x.TrailerNumber}</MenuItem>))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Stack direction="row" spacing={2}>
                    <Button onClick={handleClose} text={"Cancel"} />
                    <Button onClick={handleSaveAndClose} text={"Save"} color={"secondary"} />
                </Stack>
            </DialogActions>
        </Dialog>
    </>);
}

function AssignDayDialog(props: { currentDayOfWeek: any; currentRouteData: any; updateView: any; }) {
    const { currentDayOfWeek, currentRouteData, updateView } = props;

    const [open, setOpen] = React.useState(false);
    const [dayOfWeek, setDayOfWeek] = React.useState(currentDayOfWeek); // defaults to sunday?
    React.useEffect(() => {
        setDayOfWeek(currentDayOfWeek)
    }, [currentDayOfWeek]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSaveAndClose = () => {
        const save = async function () {
            try {
                // const result
                console.log(currentRouteData);
                await axios.put(`${process.env.REACT_APP_ENDPOINT}/api/Loads/${currentRouteData.id}`, {
                    day_of_week: dayOfWeek
                });
                updateView().then(() => setOpen(false));
            } catch (e) {
                console.log(e);
                // setResult(e);
            }
        };
        // setOpen(false);
        save().then();
    }

    const handleChange = (event: { target: { value: any; }; }) => {
        setDayOfWeek(event.target.value);
    };

    /*
    getAssignedValueOrDefault(currentRouteData, 'trailer', 'TrailerNumber', null)
    <div>
                                <p style={{lineHeight: '3', verticalAlign: "middle"}}>
                                    Day Of Week:
                    <span style={{color: (currentRouteData !== undefined && currentRouteData['day_of_week'] !== undefined && currentRouteData['day_of_week'] !== null)? "black": 'red'}}>{
                        (currentRouteData !== undefined && currentRouteData['day_of_week'] !== undefined && currentRouteData['day_of_week'] !== null) ?
                            DAYS_OF_WEEK[currentRouteData['day_of_week']] : "[No Day Of Week Assigned]"
                    }</span>
                    </p>
                    </div>

     */

    return (<>
        <MTLButton
            variant="contained"
            color={(currentRouteData !== undefined && currentRouteData['day_of_week'] !== undefined && currentRouteData['day_of_week'] !== null && DAYS_OF_WEEK[currentRouteData['day_of_week'] - 1] !== undefined) ? "primary" : "warning"}
            fullWidth={true}
            onClick={(event) => {
                event.stopPropagation();
                handleClickOpen();
            }}
        >Assign Day Of Week [{
                (
                    currentRouteData !== undefined &&
                    currentRouteData['day_of_week'] !== undefined &&
                    currentRouteData['day_of_week'] !== null &&
                    DAYS_OF_WEEK[currentRouteData['day_of_week'] - 1] !== undefined
                    // currentRouteData['day_of_week'] !== 0
                ) ?
                    DAYS_OF_WEEK[currentRouteData['day_of_week'] - 1] :
                    "No Day Of Week Assigned"
            }]</MTLButton>
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Assign Day Of Week</DialogTitle>
            <DialogContent style={{ width: "300px" }}>
                <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-label">Day Of Week</InputLabel>
                    <Select
                        // variant={"outlined"}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={dayOfWeek}
                        label="Day Of Week"
                        onChange={handleChange}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left"
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            }
                        }}
                    // input={<OutlinedInput label="Route" />}
                    >
                        <MenuItem value="">
                            <em>Unassigned</em>
                        </MenuItem>
                        {DAYS_OF_WEEK.map((str, index) => (<MenuItem key={str} value={index + 1}>{str}</MenuItem>))}
                        {/*{routeList.map((x) => (<MenuItem value={x}>{x}</MenuItem>))}*/}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Stack direction="row" spacing={2}>
                    <MTLButton variant='contained' onClick={handleClose}><Typography variant='h6' fontWeight={700}>Save</Typography></MTLButton>
                    <MTLButton variant='contained' onClick={handleSaveAndClose} color='secondary'><Typography variant='h6' fontWeight={700}>Save</Typography></MTLButton>
                </Stack>
            </DialogActions>
        </Dialog>
    </>);
}

function PrintDialog(props: { currentRouteData: any; }) {
    const { currentRouteData } = props;

    const [open, setOpen] = React.useState(false);
    const [overrideChecked, setOverrideChecked] = React.useState(false);
    React.useEffect(() => {
        setOverrideChecked(false)
    }, [open]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSaveAndClose = async () => {
        // alert("Print?");

        // alert(JSON.stringify(currentRouteData.id));

        // <Viewer ref={viewerRef} />

        // TODO: generate PDF here.
        // try {
        //     let response = await axios.put(`/logistic/shipLoad/${currentRouteData.id}`, { Shipped: true });
        //     console.log(response);
        // } catch (e) {
        //     console.error(e);
        // }

        setOpen(false);
    }


    const isTruckAssigned = () => {
        return getAssignedValueOrDefault(currentRouteData, 'truck', 'id', null) !== null;
    }

    const isTrailerAssigned = () => {
        return getAssignedValueOrDefault(currentRouteData, 'trailer', 'id', null) !== null
    }

    const isDriverAssigned = () => {
        return getAssignedValueOrDefault(currentRouteData, 'driver', 'id', null) !== null;
    }

    // const isDayOfWeekAssigned = () => {
    //     return getAssignedValueOrDefault(currentRouteData, 'truck', 'Capacity', null) !== null;
    // }

    const isTrailerNeeded = () => {
        return getAssignedValueOrDefault(currentRouteData, 'truck', 'Capacity', 0) === 0;
    }

    const trailerStatus = () => {

        let statusIcon = null;

        if (isTrailerNeeded()) {
            if (isTrailerAssigned()) {
                statusIcon = (<FontAwesomeIcon style={{ color: 'green' }} icon={faCheckCircle} />);
            } else {
                statusIcon = (<FontAwesomeIcon style={{ color: 'red' }} icon={faTimesCircle} />);
            }
        } else {
            if (isTrailerAssigned()) {
                statusIcon = (<FontAwesomeIcon style={{ color: 'red' }} icon={faPlusCircle} />);
            } else {
                statusIcon = (<FontAwesomeIcon style={{ color: 'gray' }} icon={faMinusCircle} />);
            }
        }

        return statusIcon;
    }

    const isValidCapacity = () => {
        if (
            currentRouteData !== undefined && currentRouteData.deliveries !== undefined &&
            Array.isArray(currentRouteData.deliveries) && currentRouteData.deliveries.length > 0
        ) {
            let totalFilled = 0;
            if (Array.isArray(currentRouteData.deliveries) && currentRouteData.deliveries.length > 0) {
                currentRouteData.deliveries.forEach((delivery: { items: any[]; }) => {
                    totalFilled += delivery.items.reduce((t: number, item: { orderdQty: any; brokerMaterialNumber?: any; }) => {
                        return t + get_number_of_trays_per_cart(item, item.orderdQty);
                    }, 0);
                })
            }
            // return Math.ceil(totalFilled );
            // let totalFilled = 0;
            // currentRouteData.deliveries.forEach((delivery) => {
            //     let list = delivery.items.map(item => item.OrderdQty );
            //     totalFilled += list.reduce((t, s) => parseInt(t) + parseInt(s), 0);
            // })

            let loadFilled = Math.ceil(totalFilled);
            // let loadFilled = currentRouteData.deliveries.map(d=> d.number_of_carts).reduce((t, v) => (t + v));
            let loadCapacity = getAssignedValueOrDefault(currentRouteData, 'truck', 'Capacity', 0) +
                getAssignedValueOrDefault(currentRouteData, 'trailer', 'Capacity', 0);

            if (loadCapacity > 0 && loadFilled <= loadCapacity) {
                return true
            }
        }
        return false;
    }

    const isValidForPrint = () => {
        return isTruckAssigned() && (!isTrailerNeeded() || isTrailerAssigned()) && isDriverAssigned() && (isValidCapacity() || overrideChecked);
    };

    return (<>
        <MTLButton
            // disabled={true}
            variant="contained"
            color="primary"
            fullWidth={true}
            onClick={(event) => {
                event.stopPropagation();
                handleClickOpen();
            }}
        >Print Shipment</MTLButton>
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Print Shipment</DialogTitle>
            <DialogContent style={{ width: "300px" }}>
                {/*<pre>{JSON.stringify(currentRouteData, undefined, 4)}</pre>*/}
                <List style={{ width: '100%' }}>
                    <ListItem disablePadding>
                        {/*secondary={JSON.stringify(getAssignedValueOrDefault(currentRouteData, 'truck', 'id', null))}*/}
                        <ListItemText primary="Assign Truck" />
                        <ListItemIcon style={{ textAlign: "right", minWidth: '16px' }}>
                            {
                                (isTruckAssigned()) ?
                                    (<FontAwesomeIcon style={{ color: 'green' }} icon={faCheckCircle} />) :
                                    (<FontAwesomeIcon style={{ color: 'red' }} icon={faTimesCircle} />)
                            }
                        </ListItemIcon>
                    </ListItem>
                </List>
                <List style={{ width: '100%' }}>
                    <ListItem disablePadding>
                        <ListItemText primary="Assign Trailer" />
                        <ListItemIcon style={{ textAlign: "right", minWidth: '16px' }}>
                            {trailerStatus()}
                        </ListItemIcon>
                    </ListItem>
                </List>
                <List style={{ width: '100%' }}>
                    <ListItem disablePadding>
                        <ListItemText primary="Assign Driver" />
                        <ListItemIcon style={{ textAlign: "right", minWidth: '16px' }}>
                            {
                                (isDriverAssigned()) ?
                                    (<FontAwesomeIcon style={{ color: 'green' }} icon={faCheckCircle} />) :
                                    (<FontAwesomeIcon style={{ color: 'red' }} icon={faTimesCircle} />)
                            }
                        </ListItemIcon>
                    </ListItem>
                </List>
                <List style={{ width: '100%' }}>
                    <ListItem disablePadding>
                        <ListItemText primary="Capacity" />
                        <ListItemIcon style={{ textAlign: "right", minWidth: '16px' }}>
                            {/*<FontAwesomeIcon icon={faCheckCircle} />*/}
                            {
                                (isValidCapacity()) ?
                                    (<FontAwesomeIcon style={{ color: 'green' }} icon={faCheckCircle} />) :
                                    (<FontAwesomeIcon style={{ color: 'red' }} icon={faTimesCircle} />)
                            }
                        </ListItemIcon>
                    </ListItem>
                </List>
                {(!isValidCapacity()) && (
                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={overrideChecked}
                            onChange={(event, checked) => setOverrideChecked(checked)} />}
                            label="Override Capacity" />
                    </FormGroup>
                )}

                {/*{overrideChecked ? "checked": "unchecked"}*/}
                <MTLButton disabled={!isValidForPrint()} fullWidth={true} onClick={handleSaveAndClose} color={"secondary"}>Print</MTLButton>
            </DialogContent>
            <DialogActions>
                <Stack direction="row" spacing={2}>
                    <Button onClick={handleClose} text={"Close"} />
                </Stack>
            </DialogActions>
        </Dialog>
    </>);
}


function CapacityDialog(props: { open: any; setOpen: any; }) {
    const { open, setOpen } = props;
    // const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (<>
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Load Capacity Exceeded</DialogTitle>
            <DialogContent style={{ width: "300px" }}>
                <h6>Load is over capacity.</h6>
            </DialogContent>
            <DialogActions>
                <Stack direction="row" spacing={2}>
                    <Button onClick={handleClose} text={"Close"} />
                </Stack>
            </DialogActions>
        </Dialog>
    </>);
}

const DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
let shipWeeks = GenerateSample([
    { key: "value", type: (i: any) => RowNumber(i) },
    { key: "label", type: (i: any) => "Week " + RowNumber(i) },
], 53);

const CapacityPill = (props: { used: any; capacity: any; }) => {
    const { used, capacity } = props;
    let color = undefined;
    if (used > capacity) {
        color = "#C70000";
    } else if (used > capacity * 0.9 && used <= capacity) {
        color = "#7DAA00";
    } else {
        color = "#E8AB00";
    }
    return (
        <div style={{
            width: '8ch',
            borderRadius: '20px',
            height: '40px',
            backgroundColor: color,
            border: '1px solid black'
        }}>
            <p style={{
                width: '100%', textAlign: 'center', zIndex: 4,
                position: 'relative', top: 'calc(20px - 0.75rem)'
            }}>{used}/{capacity}
            </p>
        </div>
    );
};

export function Scheduler(props: any) {

    /*     const dispatch = useAppDispatch();
    
        useEffect(() => {
          let appState: IApplication = {
            pageTitle: "Tray Import",
            backgroundPath: "/assets/images/inventorybg.jpg"
          }
          dispatch(setPageTitle(appState));
        }, []); */

    const { } = props;

    const [formFilter, setFormFilter] = React.useState({
        week_year: `${new Date().getFullYear()}-${convertDateToBallCalendar(new Date())}`
    });
    const [capacityDialogOpen, setCapacityDialogOpen] = React.useState(false);

    const [driverList, setDriverList] = React.useState([]);
    const [truckList, setTruckList] = React.useState([]);
    const [trailerList, setTrailerList] = React.useState([]);

    const loadDriverList = async function () {
        try {
            // const result
            const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Drivers`);
            setDriverList(response.data);
            // setExpanded(expanded);
        } catch (e) {
            console.log(e);
            // setResult(e);
        }
    };
    const loadTruckList = async function () {
        try {
            // const result
            const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Trucks`);
            console.log("TRUCKS", response.data);
            setTruckList(response.data);
            // setExpanded(expanded);
        } catch (e) {
            console.log(e);
            // setResult(e);
        }
    };
    const loadTrailerList = async function () {
        try {
            // const result
            const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Trailers`);
            setTrailerList(response.data);
            // setExpanded(expanded);
        } catch (e) {
            console.log(e);
            // setResult(e);
        }
    };

    const [routes, setRoutes] = React.useState([]);

    const loadRoutes = async function () {
        try {

            let [selectedYear, selectedWeek] = formFilter['week_year'].split("-");

            console.log(selectedWeek, selectedYear);

            const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Routes/`); ///${selectedWeek}/${selectedYear}

            setRoutes(response.data.sort((a: { loads: string | any[]; }, b: { loads: string | any[]; }) => {
                let loadCountA = a.loads.length;
                let loadCountB = b.loads.length;
                return loadCountA > loadCountB ? -1 : 1
            }));
        } catch (e) {
            console.log(e);
        }
    };

    React.useEffect(() => {
        loadRoutes();
        loadDriverList();
        loadTruckList();
        loadTrailerList();
    }, []);

    const updateView = async function () {
        await Promise.allSettled(
            [
                loadRoutes(),
            ]
        );
    };

    const [selectedRouteIndex, setSelectedRouteIndex] = React.useState<any>(0);
    const [selectedLoadIndex, setSelectedLoadIndex] = React.useState<any>(0);

    const [selectedRoute, setSelectedRoute] = React.useState<any>(undefined);
    React.useEffect(() => {
        setSelectedRoute(routes[selectedRouteIndex]);
    }, [selectedRouteIndex, routes])

    const [selectedLoad, setSelectedLoad] = React.useState<any>(undefined);
    React.useEffect(() => {
        if (selectedRoute === undefined || selectedRoute.loads === undefined) {
            setSelectedLoad(undefined);
            return;
        }
        setSelectedLoad(selectedRoute.loads[selectedLoadIndex]);
    }, [selectedRoute, selectedLoadIndex])

    const [routeDialogOpen, setRouteDialogOpen] = React.useState<any>(false);

    const columns : any = [
        {
            field: "change_route_button_dialog",
            headerName: ' ',
            width: 150,
            sortable: false, filterable: false,
            renderCell: (cellValues: any) => {
                return (
                    <>
                        {/*<pre>{JSON.stringify(selectedRoute)}</pre>*/}
                        <RouteDialog
                            // currentDeliveryNumber={cellValues.row['BrokerDeliveryID']}
                            // delivery={cellValues.row}
                            cellValues={cellValues}
                            currentLoad={(selectedRoute.id !== undefined && selectedRoute.id !== null) ? selectedRoute.id : ""}
                            currentRoute={(selectedRoute.logistics_route_id !== undefined && selectedRoute.logistics_route_id !== null) ? selectedRoute.logistics_route_id : ""}
                            routes={routes}
                            updateView={() => {
                                // loadRoutes().then();
                                updateView().then();
                            }}
                            onOpen={() => setRouteDialogOpen(true)}
                            onClose={() => setRouteDialogOpen(false)}
                        />
                    </>
                );
            }
        },
        { field: 'brokerDeliveryID', headerName: 'Delivery #', width: 200 },
        // {field: 'CustomerName', headerName: 'Customer Name', width: 200},
        { field: 'soldToName', headerName: 'Customer Name', width: 200 },
        { field: 'shipToCity', headerName: 'City', width: 200 },
        { field: 'shipToState', headerName: 'State', width: 200 },
        // {field: 'Location', headerName: 'City', width: 150},
        // {field: 'State', headerName: 'State', width: 110},
        {
            field: "number_of_items", headerName: "# of Items", width: 150,
            valueGetter: (cellParams: { row: { deliveryItems: string | any[] | null | undefined; }; }) => (cellParams.row.deliveryItems !== null && cellParams.row.deliveryItems !== undefined) ? cellParams.row.deliveryItems.length : 0
        },
        {
            field: 'number_of_trays', headerName: '# of Trays', width: 200,
            valueGetter: (cellParams: { row: { deliveryItems: any[] | undefined; }; }) => {
                if (cellParams.row.deliveryItems === undefined) return 0;
                let list = cellParams.row.deliveryItems.map((item: { orderedQuantity: any; }) => item.orderedQuantity);
                return list.reduce((t: string, s: string) => parseInt(t) + parseInt(s), 0);
            }
        },
        {
            field: 'number_of_carts', headerName: '# of Carts', width: 200,
            renderCell: (cellValues: { row: { deliveryItems: any[] | undefined; }; }) => {
                let totalFilled = 0;
                let isOneFlagged = false;
                if (cellValues.row.deliveryItems !== undefined) {
                    totalFilled += cellValues.row.deliveryItems.reduce((t: number, item: { orderedQuantity: any; brokerMaterialNumber?: any; }) => {
                        if (isFlaggedNumberOfCarts(item)) {
                            isOneFlagged = true;
                        }
                        return t + get_number_of_trays_per_cart(item, item.orderedQuantity);
                    }, 0);
                }
                let cartCount = Math.ceil(totalFilled);
                return (
                    <>
                        <span style={{ color: isOneFlagged ? "#9C27B0" : "black" }}>{cartCount}</span>
                    </>
                );
            }
        },
        { field: 'loadOrder', headerName: 'Load Order', width: 200, editable: true },
    ]

    const formSubject = new Subject();
    const formStructure = [
        {
            size: { default: 4 },
            type: "week-select",
            key: 'week_year',
            label: "Ship Week",
            // options: shipWeeks
        },
    ];

    formSubject.subscribe((n: any) => setFormFilter(n));
    React.useEffect(() => {
        // loadData().then();
        // loadRoutes().then();
        loadRoutes().then();
    }, [formFilter['week_year']]);

    const [currentLoadFilled, setCurrentLoadFilled] = React.useState(0);
    const [currentLoadCapacity, setCurrentLoadCapacity] = React.useState(0);
    React.useEffect(() => {
        console.log("SELECTED LOAD UPDATED", selectedLoad);
        if (
            selectedLoad !== undefined && selectedLoad.deliveries !== undefined &&
            Array.isArray(selectedLoad.deliveries) && selectedLoad.deliveries.length > 0
        ) {

            let totalFilled = 0;
            if (Array.isArray(selectedLoad.deliveries) && selectedLoad.deliveries.length > 0) {
                selectedLoad.deliveries.forEach((delivery: { items: any[]; }) => {
                    totalFilled += delivery.items.reduce((t: number, item: { orderdQty: any; brokerMaterialNumber?: any; }) => {
                        let val = get_number_of_trays_per_cart(item, item.orderdQty)
                        console.log(`${item} = ${val}`);
                        return t + val;
                    }, 0);
                })
            }

            let loadFilled = Math.ceil(totalFilled);
            let loadCapacity = getAssignedValueOrDefault(selectedLoad, 'truck', 'Capacity', 0) +
                getAssignedValueOrDefault(selectedLoad, 'trailer', 'Capacity', 0);

            setCurrentLoadFilled(loadFilled);
            setCurrentLoadCapacity(loadCapacity);

            if (loadCapacity > 0 && loadFilled > loadCapacity) {
                setCapacityDialogOpen(true);
            }
        } else if (selectedLoad !== undefined) {
            let loadCapacity = getAssignedValueOrDefault(selectedLoad, 'truck', 'Capacity', 0) +
                getAssignedValueOrDefault(selectedLoad, 'trailer', 'Capacity', 0);
            setCurrentLoadCapacity(loadCapacity);
            setCurrentLoadFilled(0);
        } else {
            setCurrentLoadFilled(0)
            setCurrentLoadCapacity(0);
        }
    }, [selectedLoad]);

    const onCellEditCommit = async (cellEdit: { field: any; value: any; id: any; }) => {
        console.log(cellEdit);
        let data = { field: cellEdit.field, value: cellEdit.value };
        const resp = await axios.put(
            `${process.env.REACT_APP_ENDPOINT}/api/DeliveryHeader/${cellEdit.id}`,
            data
        );
        console.log(resp);
    }

    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: '#89B219',
            },
        },
    });

    const [searchInformation, setSearchInformation] = React.useState<ISearchChips>();

    const handleSearchChips = (searchInformation: ISearchChips) => {
        setSearchInformation(searchInformation);
    }

    return (
        <>
            <div className="Scheduler" style={{ height: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

                    <ThemeProvider theme={darkTheme}>
                        <SearchChips handleSearch={handleSearchChips}></SearchChips>
                    </ThemeProvider>
                    <div style={{ borderBottom: '0.5px dotted black', height: '54.5px' }}>
                        <Tabs
                            variant={"scrollable"} scrollButtons={"auto"} style={{
                                backgroundColor: "grey",
                                color: "#FFFFFF"
                            }}
                            value={selectedRouteIndex} onChange={(x, y) => setSelectedRouteIndex(y)}
                        >
                            {routes.map((route: any) => {
                                let loadCount = route.loads.length;
                                let label = loadCount > 0 ? `${route.name} (${loadCount})` : route.name;
                                // label = JSON.stringify(route.loads)
                                return (<Tab style={{ height: '54.5px' }} key={route.id} label={label}
                                    disabled={route.loads.length === 0} />);
                            })}
                        </Tabs>
                    </div>


                    {selectedRoute !== undefined && (
                        <div style={{ borderBottom: '0.5px dotted black', height: '54.5px' }}>
                            <Tabs
                                variant={"scrollable"} scrollButtons={"auto"} style={{
                                    borderTop: '1px solid black', height: '54.5px'
                                }}
                                value={selectedLoadIndex} onChange={(x, y) => setSelectedLoadIndex(y)}
                            >
                                {selectedRoute.loads.map((load: { id: React.Key | null | undefined; loadNumber: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | React.ReactPortal | null | undefined; }) => {
                                    return (<Tab style={{ height: '54.5px' }} key={load.id} label={load.loadNumber} onClick={() => setSelectedLoad(load)}  />);
                                })}
                            </Tabs>
                        </div>)}


                    {selectedRoute !== undefined && selectedLoad !== undefined && (<div style={{
                        backgroundColor: 'white',
                        display: 'block',
                        height: '3rem',
                        paddingLeft: '0.5rem',
                        paddingRight: '0.5rem'
                    }}>
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "0.5rem",
                            justifyContent: "space-evenly",
                            justifyItems: 'center'
                        }}>
                            <div>

                            </div>
                            <div style={{ height: '3rem', paddingTop: '0.3rem' }}>
                                <AssignTruckDialog currentTruck={selectedLoad['trailer_number']} currentRouteData={selectedLoad} updateView={updateView} truckList={truckList} />
                            </div>
                            <div style={{ height: '3rem', paddingTop: '0.3rem' }}>
                                <AssignTrailerDialog currentTrailer={selectedLoad['trailer_number']} currentRouteData={selectedLoad} updateView={updateView} trailerList={trailerList} />
                            </div>
                            <div style={{ height: '3rem', paddingTop: '0.3rem' }}>
                                <AssignDriverDialog currentRouteData={selectedLoad} updateView={updateView} driverList={driverList} />
                            </div>
                            <div style={{ height: '3rem', paddingTop: '0.3rem' }}>
                                <AssignDayDialog currentDayOfWeek={selectedLoad['day_of_week']} currentRouteData={selectedLoad} updateView={updateView} />
                            </div>

                            <div style={{ height: '3rem', paddingTop: '0.3rem', width: '8ch' }}>
                                <CapacityPill capacity={currentLoadCapacity} used={currentLoadFilled} />
                            </div>

                            <div style={{ flexGrow: 1 }} />
                            <div style={{ height: '3rem', paddingTop: '0.3rem' }}>
                                <PrintDialog currentRouteData={selectedLoad} />
                            </div>
                        </div>
                    </div>
                    )}


                    {selectedRoute !== undefined && selectedLoad !== undefined && (<div style={{
                        flexGrow: 1
                    }}>
                        <div style={{ height: 'calc(100vh - 156px)', width: '100%' }}>
                            <DataGrid
                                className={"DataGrid"}
                                rows={(selectedLoad.deliveryHeaders === undefined) ? [] : selectedLoad.deliveryHeaders}
                                columns={columns}
                                rowsPerPageOptions={[5, 10]}
                                checkboxSelection={false}
                                disableSelectionOnClick
                                onCellEditCommit={onCellEditCommit}
                            />
                        </div>
                    </div>)}
                </div>
                <CapacityDialog open={!routeDialogOpen && capacityDialogOpen} setOpen={setCapacityDialogOpen} />
            </div>
        </>
    )
}
